import { UrlSerializer, UrlTree, DefaultUrlSerializer } from '@angular/router';

export class DfUrlSerializer extends DefaultUrlSerializer implements UrlSerializer {
    override serialize(tree: UrlTree): any {
        const path = super.serialize(tree);
        //  alllow these characters
        return path.replace(/%3F/g, '?').replace(/%3D/g, '=').replace(/%26/g, '&');
    }
}
